/**
 * API клієнт для ref.sales_channels (Порція Роздріб.2/5a).
 * Backend: /api/v1/retail/sales-channels. Permissions: retail.sales_channel.manage.
 */
import { api } from './client';
import type { Page } from './catalogs';

export type ChannelType =
  | 'pos'
  | 'online_store'
  | 'marketplace_rozetka'
  | 'marketplace_prom'
  | 'other';

export interface SalesChannel {
  id: string;
  organization_id: string;
  code: string;
  name: string;
  channel_type: ChannelType;
  config: Record<string, unknown>;
  is_active: boolean;
  deletion_mark: boolean;
  created_at: string;
  created_by: string | null;
  comment: string | null;
}

export interface SalesChannelCreate {
  organization_id: string;
  code: string;
  name: string;
  channel_type?: ChannelType;
  config?: Record<string, unknown>;
  is_active?: boolean;
  comment?: string | null;
}

export type SalesChannelUpdate = Partial<Omit<SalesChannelCreate, 'organization_id'>>;

export const retailSalesChannels = {
  list: (params?: { organization_id?: string; is_active?: boolean; limit?: number; offset?: number }) =>
    api.get<Page<SalesChannel>>('/retail/sales-channels', { params }).then((r) => r.data),
  get: (id: string) => api.get<SalesChannel>(`/retail/sales-channels/${id}`).then((r) => r.data),
  create: (payload: SalesChannelCreate) =>
    api.post<SalesChannel>('/retail/sales-channels', payload).then((r) => r.data),
  update: (id: string, payload: SalesChannelUpdate) =>
    api.patch<SalesChannel>(`/retail/sales-channels/${id}`, payload).then((r) => r.data),
  remove: (id: string) => api.delete(`/retail/sales-channels/${id}`).then(() => undefined),
};
